import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "container" }
const _hoisted_2 = { class: "ion-text-start" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", null, "Herausgeber der thingTAG-Mittelalter-App", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.imareal.sbg.ac.at/",
    target: "_blank"
  }, "Institut für Realienkunde des Mittelalters und der frühen Neuzeit der Universität Salzburg"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://izmf.sbg.ac.at/",
    target: "_blank"
  }, "Interdisziplinäres Zentrum für Mittelalter und Frühneuzeit"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Körnermarkt 13"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 3500 Krems an der Donau"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Österreich"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Kontakt: "),
  /*#__PURE__*/_createElementVNode("a", { href: "mailto:isabella.nicka@plus.ac.at" }, "isabella.nicka@plus.ac.at"),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h4", null, "Autorinnen der Texte: ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "Miriam Landkammer, Isabella Nicka", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h4", null, "Gestaltung und technische Umsetzung: ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.informationsgesellschaft.com/",
    target: "_blank"
  }, "Die Informationsgesellschaft mbH"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("i", null, "Digitale Informationssysteme und Kommunikationsdesign"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Bornstraße 12-13"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" D-28195 Bremen / Germany"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Telefon: +49 (0)421 17889-0"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Telefax: +49 (0)421 17889-10"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" E-Mail: info@informationsgesellschaft.com"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Internet: www.informationsgesellschaft.com")
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h4", null, "Nutzungsbedingungen", -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Hier finden Sie Informationen zu den ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" und Haftungsausschluss.")
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h4", null, "Änderungsübersicht:", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", null, "thingTAG Version 1.0", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_header = _resolveComponent("page-header")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_side_menu = _resolveComponent("side-menu")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_page_header, {
        title: _ctx.$t('message.impressum')
      }, null, 8, ["title"]),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_ion_grid, { class: "ion-padding" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_row, { class: "ion-justify-content-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, {
                      "size-xs": "12",
                      "size-sm": "12",
                      "size-md": "12",
                      "size-lg": "6"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t('message.impressum')), 1),
                        _hoisted_3,
                        _createElementVNode("section", null, [
                          _hoisted_4,
                          _hoisted_5,
                          _hoisted_6,
                          _hoisted_7,
                          _hoisted_8,
                          _hoisted_9,
                          _createElementVNode("p", null, [
                            _hoisted_10,
                            _createElementVNode("a", {
                              onClick: _cache[0] || (_cache[0] = () => { _ctx.router.push('/disclaimer'); }),
                              title: "Nutzungsbedingungen"
                            }, "Nutzungsbedingungen"),
                            _hoisted_11
                          ]),
                          _hoisted_12,
                          _hoisted_13
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_side_menu, { showGoBack: true })
    ]),
    _: 1
  }))
}